module.exports = __webpack_public_path__ + "static/media/Check.bbb3baa4.svg";